<template>
  <div class="pravo-sirsi">
    <Search />
    <div class="pravo-sirsi__tables">
      <GamesTable :sourceData="myGames" type="my" @action="continueGame" />
      <br />
      <GamesTable :sourceData="allGames" type="all" @action="joinLobby" />
      <template v-if="false">
        <br />
        <GamesTable
          :sourceData="archivedGames"
          type="archived"
          @action="reviewGame"
        />
      </template>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import stompSocket from "../../plugins/socketIO";
import { mapGetters } from "vuex";
import Search from "@/components/welcome/pravo/Search.vue";
import GamesTable from "@/components/welcome/GamesTable.vue";

export default {
  name: "JoinOverview",
  components: {
    Search,
    GamesTable,
  },
  data() {
    return {
      teamName: "",
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      myGames: "myGames",
      allGames: "allGames",
      archivedGames: "archivedGames",
      amIAdmin: "amIAdmin",
      joinedGame: "joinedGame",
    }),
    isDevMode() {
      return process.env.NODE_ENV === "development";
    },
  },
  mounted() {
    this.$store.clearGameState();
    stompSocket.unsubscribe();
    this.$store.dispatch("fetchGames");
  },
  methods: {
    createMockGame() {
      this.$store.dispatch("createMockGame");
    },
    async joinLobby(id) {
      await this.$store.dispatch("toggleLoader", true);
      const result = await this.$store.dispatch("join", { id });
      if (result) {
        await this.$router.push({ name: "Lobby" });
      }
    },
    continueGame(game) {
      if (_.get(this.$store.getters.me, "game.startedTime")) {
        this.$router.push({ name: "Game.GameOverview" });
      } else if (this.$store.getters.joinedGame) {
        this.$router.push({ name: "Lobby" });
      }
    },
    reviewGame() {
      //
    },
  },
};
</script>

